import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@ui/constants';
import type { IPaginationState } from '../types/form.types';

// Re-export STEP_IDS from types for convenience
export { STEP_IDS } from '../types/form.types';
export type { StepId } from '../types/form.types';

/**
 * Default pagination settings for patient lists
 * Uses IPaginationState with required current and pageSize
 */
export const DefaultPagination: IPaginationState = {
    current: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 100,
};

/**
 * Patient table column widths (in pixels)
 */
export const COLUMN_WIDTHS = {
    PATIENT_ID: 100,
    NAME: 120,
    AGE: 60,
    GENDER: 80,
    DIAGNOSIS: 150,
    LAST_VISIT: 120,
    DOCUMENT_COUNT: 100,
} as const;

/**
 * Table scroll configuration
 */
export const TABLE_SCROLL = {
    x: 800,
    y: 425,
} as const;
